import styled from 'styled-components';
import HotelUpcomingSvg from '../../assets/mytrips/hotel-upcoming.svg';

const HotelUpcomingIcon = styled(HotelUpcomingSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.5rem'};
  height: ${props => props.height || '2.5rem'};
  margin: ${props => props.margin};
`;

export default HotelUpcomingIcon;
